module.exports = __webpack_public_path__ + "static/media/countdown-kv-mobile.3e22c46c.png";